var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights, Stack } from "@fluentui/react";
import { useStyles } from "../../utils/useStyles";
import { Text } from "../texts/Text";
var tokens = {
    root: {
        childrenGap: 20
    },
    actions: {
        childrenGap: 16
    }
};
export var FormControl = function (props) {
    var hintRequired = props.hintRequired, children = props.children, primaryAction = props.primaryAction, secondaryAction = props.secondaryAction, rest = __rest(props, ["hintRequired", "children", "primaryAction", "secondaryAction"]);
    var styles = useStyles(function (theme) { return ({
        root: {
            root: {
                background: theme.palette.white
            }
        },
        requiredHintBlock: {
            root: {
                paddingBottom: 0,
            }
        },
        requiredSymbol: {
            root: {
                color: theme.palette.redDark,
                fontWeight: FontWeights.semibold,
                paddingBottom: 0,
            }
        },
        requiredText: {
            root: {
                fontStyle: "italic",
                paddingBottom: 0,
            }
        },
    }); });
    return _jsxs(Stack, __assign({ tokens: tokens.root, styles: styles.root }, rest, { children: [hintRequired && _jsxs(Text, __assign({ block: true, styles: styles.requiredHintBlock }, { children: [_jsx(Text, __assign({ styles: styles.requiredSymbol }, { children: "*" }), void 0), " ", _jsx(Text, __assign({ styles: styles.requiredText }, { children: "Required" }), void 0)] }), void 0), children, (primaryAction || secondaryAction) && _jsxs(Stack, __assign({ horizontal: true, tokens: tokens.actions }, { children: [secondaryAction, primaryAction] }), void 0)] }), void 0);
};
//# sourceMappingURL=FormControl.js.map